import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query';
import { Stack } from '@mui/system';
import CategoriesListControls from './ResourceList/CategoriesListControls';
import ResourceCategoryList from './ResourceCategoryList';

export default function AllResourcesCategoriesList({
  categories, viewCategories, filterCategories, sortCategories,
  getCategoriesFromQuery, setCategoryExpand, searching, 
  onEditResourceProperties, onDeleteDocument, onSelectTag, onResourceUploaded,
  categoryExpand,
  onSetSearchScope, isManager, driveConfig, withQueryClient
 }) {
    const PAGE_SIZE = 10;
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
  
    // Called when user scrolls to last visible item, increase window
    const loadMore = () => {
      if (isLoadingMore) return // avoid double triggers
      setIsLoadingMore(true)
      setVisibleCount((prev) => {
        const nextCount = Math.min(prev + 1, viewCategories.length)
        // If no more to load, stop loading more
        if (nextCount === viewCategories.length) {
          setIsLoadingMore(false)
        }
        return nextCount
      })
    }
  
    // When visibleCount changes (more categories show), set isLoadingMore to false after render
    useEffect(() => {
      setIsLoadingMore(false)
    }, [visibleCount])
  
    const sentinelRef = useRef();
  
    useEffect(() => {
      if (!viewCategories || visibleCount >= viewCategories.length) return; // Don't observe when all are shown
  
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !isLoadingMore) {
          loadMore();
        }
      });
      if (sentinelRef.current) observer.observe(sentinelRef.current);
  
      return () => observer.disconnect()
    }, [visibleCount, viewCategories, isLoadingMore])

    return (
      <>
        <Stack gap={1}>
          <CategoriesListControls setCategoryExpand={setCategoryExpand} 
          defaultSelectedCategories={getCategoriesFromQuery(categories)}
          sortCategories={sortCategories}
          categories={categories}
          filterCategories={filterCategories}
          viewCategories={viewCategories}
          includeCollapse={(viewCategories?.length ?? 0) <= 20} />
          {viewCategories && viewCategories.slice(0, visibleCount).map((category, idx) => (
            <ResourceCategoryList key={category}
                category={category}
                categoriesList={categories}
                files={undefined} //{files?.[category]}
                lazyLoadFiles={true}
                working={searching}
                onEditResourceProperties={onEditResourceProperties}
                onDeleteDocument={onDeleteDocument}
                onSelectTag={onSelectTag}
                supportResourceUpload={true}
                onResourceUploaded={onResourceUploaded}
                expand={categoryExpand ?? idx === 0}
                onSetSearchScope={onSetSearchScope}
                isManager={isManager()}
                driveConfig={driveConfig}
                withQueryClient={withQueryClient}
              />
            )
          )
          }
          {/* Sentinel for infinite scroll */}
          
      </Stack>
      {viewCategories && (visibleCount < viewCategories.length) && 
            <div ref={sentinelRef} style={{ height: 1 }} />
      }
      </>
    )
}